<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>무료 온라인 문법 검사기</h1></div>
                    <p>AI에 기반한 트링카의 무료 문법 검사기로 즉석에서 글을 수정해 보세요.<br /> 단어 선택과 어조 등에 대한 제안을 통해 단순히 기본 문법에 어긋나지 않는 것 이상으로 글이 향상되도록 트링카가 도와드립니다.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="multiTabSection">
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" data-toggle="tab" href="#EnglishGrammarChecker" role="tab" aria-label="english">English</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" data-toggle="tab" href="#SpanishGrammarChecker" role="tab" aria-label="spanish">Spanish</a>
                        </li>
                        <!-- <li class="nav-item" role="presentation">
                            <a class="nav-link" data-toggle="tab" href="#GermanGrammarChecker" role="tab" aria-label="german">German</a>
                        </li> -->
                    </ul><!-- Tab panes -->
                    <div class="tab-content">
                        <div class="tab-pane active" id="EnglishGrammarChecker" role="tabpanel">
                            <app-english-grammar-checker></app-english-grammar-checker>
                        </div>
                        <div class="tab-pane" id="SpanishGrammarChecker" role="tabpanel">
                            <app-spanish-grammar-checker></app-spanish-grammar-checker>
                        </div>
                        <!-- <div class="tab-pane" id="GermanGrammarChecker" role="tabpanel">
                            <app-german-grammar-checker></app-german-grammar-checker>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <h2>즐겨찾는 웹사이트에서 무료 실시간 문법 검사를 해보세요! </h2>
                <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome"> 크롬을 위한 설치</a>
                <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">  또한 설치 가능</a>
                <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">  가장자리 위한 설치</a>
            
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>무료 트링카 계정</h2>
                    <P>월 최대 5000단어까지 글을 검사해 언어와 스타일의 전반적 향상을 확인하고</P>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">지금 바로 가입하세요!</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka_demo_wrap" style="display: none !important;">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h3>무료 온라인 문법 검사기</h3>
                        <div class="HeadingSubLine"></div>
                        <p>AI에 기반한 트링카의 무료 문법 검사기로 즉석에서 글을 수정해 보세요.<br /> 단어 선택과 어조 등에 대한 제안을 통해 단순히 기본 문법에 어긋나지 않는 것 이상으로 글이 향상되도록 트링카가 도와드립니다.</p>
                    </div>
                </div>
            </div>
            <div class="row match-box">
                <div class="col-lg-8 dflex">
                    <div class="editor_sections c-card" style="height:100%;">
                        <div class="gcLoaderSection" *ngIf="showloader">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                </circle>
                            </svg>
                        </div>
                        <div style="display: none;" class="loading loader" #loading>&#8230;</div>
                        <div class="editor_top_section" [ngClass] = "(wordCount > maxLength) ? 'redWord' : '' ">
                            <!-- <span (click)="addDummyText()" class="dummy-text">Example text</span> -->
                            <span class="dorpdownText">
                                <button mat-button [matMenuTriggerFor]="sample" class="tryDemo_exampleText file_manager_dropdown">
                                    <!-- <img class="img-fluid" src="../../../../assets/images/UseExampleText.svg" alt="logo favicon"> -->
                                    <span>예제 텍스트<i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </button>
                                <mat-menu #sample="matMenu" class="file_manager_sub_menus new_file_sections">
                                    <mat-radio-group aria-label="Select an option" (change)="addSampleData($event)" name="example">
                                        <ng-container *ngFor="let data of sampleData;index as i;">
                                            <mat-radio-button value="{{data.key}}">{{data.key}} </mat-radio-button><br>
                                        </ng-container>
                                    </mat-radio-group>
                                </mat-menu>
                            </span>
                            <span class="float-right word_count_section">단어: <b>{{wordCount}}/{{maxLength}}</b></span>
                        </div>

                        <!-- <div class="ck-editor" z>
                            <ck-editor name="editor1" [(ngModel)]="editorValue" [config]="config" language="en"
                                [fullPage]="false" (change)="onChange($event)" (blur)="onBlur($event)"
                                (focus)="onFocus($event)" (focusout)="outFocus($event)" (mouseup)="onMouseUp($event)"
                                (paste)="onPaste($event)" (keyup)="onKeyUp($event)" placeholder="Write your message">
                            </ck-editor>
                        </div> -->
                        <div class="ck-editor" style="height:280px; overflow: auto;">
                            <textarea #sampleEditor id ="sampleEditor" style="height: 100%;width: 100%;border: none;padding: 10px;outline: 0;display: block ;" (keyup)="onChange($event)" (paste)="onChange($event)" (change)="onChange($event)"></textarea>
                        </div>
                        <div class="Footer_button_section">
                            <div class="footer_radionButtons">
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation2"
                                        [checked]="languageSelection == 'us'" name="radio-stacked" value="us"
                                        name="style" (change)="languageTypeSelect('us')" required>
                                    <label class="custom-control-label mr-3"
                                        for="customControlValidation2">English-US</label>
                                </div>
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation3"
                                        [checked]="languageSelection == 'uk'" name="radio-stacked" value="uk"
                                        name="style" (change)="languageTypeSelect('uk')" required>
                                    <label class="custom-control-label"
                                        for="customControlValidation3">English-UK</label>
                                </div>
                            </div>
                            <div class="check_emailBox">
                                <!-- <input type="text" class="form-control" id="text-email" placeholder="Enter your email"
                                    [(ngModel)]="emailAdress"> -->
                                <button id="checkMyWritingButton" (click)="onGrammarCheck($event)" [disabled]="enableCheck || isProcessStarted"
                                    class="btn btn-primary">내 글 확인
                                    <div class="gcLoaderSection" *ngIf="isProcessStarted">
                                        <svg style="margin: auto; display: block;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: inline-block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                            <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                            </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                            </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                            </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                            </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                            </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                            </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                            </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                            </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                            </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                            </circle>
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="myWriting_text">By clicking Check My Writing, you are agreeing to our <a
                            routerLink="/termsofservices/">Terms of Service</a> and <a
                            routerLink="/privacypolicy/">Privacy Policy</a>.</p> -->
                              
                </div>

                <div class="col-lg-4 dflex">
                    <div class="gcResultSection c-card">
                        <div class="trinkaPluginGCSection">
                            <h2>무료 트링카 계정</h2>
                            <P>월 최대 5000단어까지 글을 검사해 언어와 스타일의 전반적 향상을 확인하고</P>
                            <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">지금 바로 가입하세요!</a>
                            <h3>특징:</h3>
                            <ul>
                                <li>문법 및 철자 오류</li>
                                <li>단어 선택</li>
                                <li>언어 향상</li>
                                <li>글쓰기 조언</li>
                            </ul>
                        </div>
                        <!-- <div class="editor_options_with_cards" *ngIf="alertErrorMessage == 'TRUE' &&!gec_result.length">
                            <h2>The issues detected in your text will be displayed here.</h2>
                            <h3>Our robust correction algorithm checks your English text for</h3>
                            <ul>
                                <li>Grammar errors</li>
                                <li>Spelling mistakes</li>
                                <li>US–UK spellings</li>
                                <li>Word usage</li>
                                <li>Language enhancement</li>
                                <li>Writing advice</li>
                            </ul>
                        </div> -->
    
                        <h4 *ngIf="!noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
                        <h4 *ngIf="!gec_result.length && noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
    
                        <div *ngIf="gec_result.length" class="mt-0 font-14 issueCountLabel-wrap">
                            <span class="issueCountLabel"> Issues Found: <span class="errors-ctn">{{gec_result.length}}</span></span>
                        </div>
    
                        <div class="errorPanel" *ngIf="gec_result.length">
                            <mat-accordion>
                                <ng-container *ngFor="let item of gec_result ; let j = index">
                                    <mat-expansion-panel class="mat-expansion-panel-spacing mb-2 mt-0 error-type"
                                        *ngIf="!item.isCorrected" (opened)="setStep(item, j)" (closed)="setStepOff(item, j)"
                                        [ngClass]="injectErrorClass(item)" [expanded]="j === 0">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <ng-container *ngIf="!item.isExpanded">
    
                                                    <div>
                                                        <strong> {{item.covered_text}}</strong>
                                                    </div>
                                                    <span *ngIf="item.error_type[0] == 1">&nbsp;(Grammar)</span>
                                                    <span *ngIf="item.error_type[0] == 2">&nbsp;(Spelling)</span>
                                                    <span *ngIf="item.error_type[0] == 3">&nbsp;(Writing
                                                        Adviser)</span>
                                                    <span *ngIf="item.error_type[0] == 4">&nbsp;(Enhancement)</span>
                                                </ng-container>
    
                                                <div *ngIf="item.isExpanded">
                                                    <strong *ngIf="item.error_type[0] == 1">&nbsp;
                                                        Grammar</strong>
                                                    <strong *ngIf="item.error_type[0] == 2">&nbsp;
                                                        Spelling</strong>
                                                    <strong *ngIf="item.error_type[0] == 3">&nbsp; Writing
                                                        Adviser</strong>
                                                    <strong *ngIf="item.error_type[0] == 4">&nbsp;
                                                        Enhancement</strong>
                                                </div>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <span (click)="rejectChange(item,j,false)">
                                                    <img src="assets/images/delete-icon.png" alt="icon">
                                                </span>
    
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div *ngFor="let output of item.output; let k = index" class="error-main">
                                            <div class="error-inner">
                                                <div
                                                    *ngIf="(item.output[k] == '' && item.error_type[k] == 3 || item.error_type[k] == 4) && !item.cta_present[k]">
                                                    <label> {{item.covered_text}}</label>
                                                </div>
                                                <div *ngIf="item.output[k] != '' && item.cta_present[k]">
                                                    <b><s>{{item.covered_text}}</s></b> <span class="arrow"><img
                                                            src="assets/images/arrow.png" alt="icon"></span>
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">{{item.output[k]}}</label>
                                                </div>
    
                                                <div *ngIf="item.output[k] == '' && item.cta_present[k]">
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">Delete
                                                        '<span>{{item.covered_text}}</span>'</label>
                                                </div>
                                            </div>
                                            <div class="error-comment">{{item.comment[k]}}</div>
                                            <hr>
                                        </div>
                                    </mat-expansion-panel>
                                </ng-container>
                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>최고의 무료 온라인 문법 검사기</h2>
                    <div class="HeadingSubLine"></div>
                    <p>트링카는 AI에 기반한 무료 문법 검사기이자 언어 향상 작문 도우미로, 학술 및 기술 글쓰기에 가장 적합하도록 설계되어 있습니다. 고급 문법 검사 외에도 트링카는 어휘, 어조, 구문, 그 밖의 여러 가지 면에서 글의 품질을 향상시켜 드립니다. 트링카는 즉석에서 3000건 이상의 문법 검사 및 상황에 맞는 맞춤법 수정 작업을 수행하여 몇 분 내에 글을 개선해 드립니다.</p>
                    <p>트링카는 실시간으로 글쓰기 제안과 고급 문법 검사를 제공하여 전문가 및 학자들이 포말하면서도 간결하고 매력적인 글을 쓸 수 있도록 도와드립니다. 트링카의 문법 검사기는 의학, 생명과학, 물리과학, 공학, 인문학, 비즈니스 및 예술을 포함한 1300개 이상의 주제 영역을 망라하며 모범적으로 작성된 논문 및 기사 수백만 건을 바탕으로 훈련되기에 해당 주제에 가장 적절한 제안을 제공합니다.</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2>누가 이 문법 검사기를 사용할 수 있을까요?</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>트링카는 영어 글쓰기 능력을 향상하고자 하는 모든 사람에게 이상적입니다. 트링카의 무료 문법 검사 툴은 학자, 카피라이터, 마케팅 담당자, 제품 담당 팀, 블로거를 비롯한 많은 사람의 신뢰를 받고 있습니다.</p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>기본 문법 및 구두점 검사기 그 이상</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>고급 문법 검사</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>트링카는 기본 문법 및 맞춤법 검사를 넘어 글에서 고급 문법 오류를 검사하고 글쓰기 품질을 전체적으로 개선할 수 있는 언어 향상 제안을 제공합니다.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>Neither the healthy individuals nor the patient <span
                                class="wrong_text">recognize</span> <span
                                class="right_text"> recognizes</span> the visual discrepancies.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>문장 구조</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>트링카의 문장 교정기는 주제에 따라 문장 구성을 개선하는 데 도움이 됩니다. 따라서 독자가 글을 더 쉽게 이해할 수 있습니다.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>The students don't enjoy <span class="wrong_text">to go</span> <span
                                class="right_text"> going</span> over the same rules again and again.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>단어 선택</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>트링카는 글을 명확하지 않게 만드는 단어 선택 오류를 수정합니다. 트링카를 사용하여 의도를 명확하고 정확하게 전달하세요.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>One of the reasons is <span class="wrong_text">because</span> <span
                                class="right_text"> that</span> the fabrication cost <span
                                class="wrong_text">for</span> <span class="right_text"> of</span> steel
                            members depends upon the material.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="best_grammer_cards">
                    <h3>고급 맞춤법 검사</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>트링카의 무료 맞춤법 검사기는 글의 맥락을 이해하여 주제에 적합한 단어를 선택하도록 도와드립니다. 어색한 맞춤법 오류는 이제 안녕이랍니다!</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>다른 앱에서<br />
                                트링카 사용</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd_in.svg" alt="word">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/WritingMoreEffective.png" alt="writing">
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>트링카의 문법 검사기를 통해 글쓰기를 효과적으로</h2>
                    <p>다른 문장 검사기와 달리 트링카의 문법 검사기는 글을 검사하여 어조, 구조, 단어 선택, 가독성 등 전체적으로 문장을 향상시켜 드립니다. 세 가지 제품이 하나로 통합된 당사의 전문 문법 검사기를 통해 작업 흐름을 간소화하세요. 문장 검사기, 맞춤법 검사기, 구두점 검사기가 모두 이용 가능합니다.</p>
                    <p>문법 검사 이상의 서비스를 통해 글의 명확성과 간결성을 확인해 보세요.</p>
                </div>
            </div>
        </div>
        <div class="row colunmChangesSection">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>트링카의 문법 검사기로 문법 익히기</h2>
                    <p>모든 문법 교정은 배움의 기회이기도 합니다. 트링카의 문법 검사기는 오류를 강조 표시하는 것에 그치지 않고 해당 오류를 수정하는 방법도 설명하여 여러분이 더 나은 작가가 되도록 도와드립니다. 콘텐츠의 전반적인 언어 품질에 대한 지표 점수도 볼 수 있습니다.</p>
                    <p>트링카의 문법 검사기를 통해 학생들은 효과적으로 글을 쓰는 방법을 배우고 최고의 글쓰기 요령을 차근차근 익혀나갈 수 있습니다.</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="learn">
                </div>
            </div>
        </div>
    </div>
</div>

<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 testi">
                <div class="GCTestmonials">
                    <h2>고객 사용 후기 </h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">이전에 경험할 수 없었던 영문법 교정 AI 툴이네요. 특히 중요한 문법 규칙과 단어 수까지 감수해 줘서 많은 도움을 받았습니다.
                                                    </p>
                                                    <p class="authorNameText">제임스 스미스</p>
                                                    <span class="authorDesignationText">학술 에디터, 미국</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">영어가 모국어가 아닌 저자들이 올바른 영어 문법과 문체로 글을 쓰는 것은 쉬운 일이 아닙니다. 때때로 저자들은 외부의 도움이 없이,
                                                        그리고 더 나아가 학문적인 글에서 작은 실수조차 발견하기 어려울 수 있습니다. 자동보정 툴로 트링카 AI를 사용해봤는데, 제안된
                                                        수정사항과 피드백에 상당히 만족했습니다. 피드백을 통해 제안된 변경사항을 자세하고 간편하게 알려줘서 좋습니다.</p>
                                                    <p class="authorNameText">로사 디아즈 산도발</p>
                                                    <span class="authorDesignationText">물리학 및 수학 박사, 멕시코</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 주로 국내외 생물의학저널에 기고하는 과학원고의 언어, 문법, 구문 개선을 위해 트링카를 사용해 왔습니다. 인터페이스가 사용자
                                                        친화적이고 사용방법이 간단해서 매우 효율적이고 번거롭지 않아 좋습니다. 논문을 편집할 수 있는 여러 가지 옵션을 필요에 따라
                                                        사용하면서, 제가 어떤 부분에 집중해야 하는지 결정할 수 있어 아주 좋습니다. 자동 수정은 논문 작성에 큰 도움이 되고, 수정
                                                        요약을 한눈에 볼 수 있는 요약 페이지는 훌륭한 아이디어네요. </p>
                                                    <p class="authorNameText">파룩 라토어 박사</p>
                                                    <span class="authorDesignationText">조교수 및 학과장, 파키스탄</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka.ai는 문법과 맞춤법 수정을 위해 제가 가장 유용하게 사용하고 있는 도구입니다. 애플리케이션이 최적화 되어있어 잘 작동하고
                                                        빠르고 깔끔합니다! 대만족!</p>
                                                    <p class="authorNameText">밀레나 게오르기예바</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">타제품에서 검사했던 문서를 다시 트링카에서 재확인했는데, 타제품보다 더 정확한 문법 체크를 하는 것 같아요. 놀랍네요!</p>
                                                    <p class="authorNameText">디네시 굽타</p>
                                                    <span class="authorDesignationText">방사선사, 인도</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 트링카를 테스트 해봤고, 훌륭한 기능에 감명받았습니다. 기존에 사용하던 문법 검사툴보다 더 좋은것 같다는 느낌을 받았습니다.
                                                        같은 연구실 동료들에게 트링카를 사용하라고 적극
                                                        <br>추천했고, 트링카가 학계에서 널리 사용되기를 바랍니다.</p>
                                                    <p class="authorNameText">에디스 데이비스</p>
                                                    <span class="authorDesignationText">박사학위자, 영국</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">트링카 AI가 제안한 수정사항과 피드백은 놀라울 정도로 유용합니다 . 사용이 간편하고 아주
                                                        <br>편리합니다.</p>
                                                    <p class="authorNameText">누르 알 리시</p>
                                                    <span class="authorDesignationText">화학자, 사우디 아라비아</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">트링카를 사용한 것은 정말 좋은 경험이었고, 트링카를 사용하지 않고는 어떤 논문도 제출할 수 없습니다. 요약하자면, 트링카는 저의
                                                        생명을 구했어요!</p>
                                                    <p class="authorNameText">은와지 주드</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 트링카를 수정한 문서들의 최종 체크 도구로 아주 유용하게 사용하고 있습니다. 기본 수정 중에 발생하는 오류들을 쉽고 빠르게 찾는
                                                        데 큰 도움이 됩니다. 플랫폼이 정말 마음에 드네요.
                                                    </p>
                                                    <p class="authorNameText">스텀프 커티스</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 Trinka.ai이 특히 에디터/출판계 에디터/ 저널 에디터들에게 매우 흥미롭고 유용한 도구라고 생각합니다. 플랫폼에서 수정
                                                        작업을 실시간으로 빠르게 확인 할 수 있다는 점이 매우 유용했습니다.</p>
                                                    <p class="authorNameText">개러스 다이크</p>
                                                    <span class="authorDesignationText">연구원</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">저는 트랑카를 사용하고 나서 전체적인 결과물에 만족합니다. 오랫동안 그래멀리를 사용해 왔지만, 학문적 글쓰기나 기술적인 글쓰기에 있어서는
                                                        트링카가 훨씬 더 나은 선택인것 같습니다. 학술 논문 설정과 자동 파일 수정 기능이 아주 편리하고 유용합니다.</p>
                                                    <p class="authorNameText">바르가바 샤르마</p>
                                                    <span class="authorDesignationText">전염병학자, India</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">트링카는 문법 교정을 위한 저만의 도구입니다. 인공지능을 기반으로 언어 교정과 언어 향상은 글쓰기를 훨씬 더 쉽게 만들어줍니다. 문법적으로
                                                        오류가 없는 문서를 작성하는 것에 노력하는 시간을 줄일 수 있었고, 덕분에 연구에 더 집중할 수 있게 되었습니다.</p>
                                                    <p class="authorNameText">랄프 베일리</p>
                                                    <span class="authorDesignationText">신경과 의사, USA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="users">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">AMA 스타일 가이드에 근거한 문법 수정과 제안이 정말 인상적입니다! 트링카는 의학적인 글쓰기를 위한 최고의 문법 교정 도구입니다.
                                                    </p>
                                                    <p class="authorNameText">토마스 안드레스</p>
                                                    <span class="authorDesignationText">심장전문의, Brazil</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>



<div class="ready_to_levelUp" style="margin-bottom: 80px;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>망설이지 말고 지금 사용해보세요.</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank" id="grammerSignUpButton">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>무료 가입하기</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>트링카의 문법 검사기 관련 FAQ</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            트링카와 다른 무료 온라인 문법 검사기를 비교해 알아볼 수 있나요?</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>우리는 여러 가지 다른 무료 문법 검사기에서 5개 학문 분야에 걸쳐 5,778개의 단어를 테스트해 보았습니다. 확인한 항목은 수정 사항, 스타일 가이드 기본 설정, 간결성, 문맥에 따른 맞춤법 검사의 정확성이며 트링카의 성능이 단연 뛰어났습니다. 자세한 비교 내용은 <a  [routerLink]="['/trinka-vs-grammarly-vs-language-tool']">비교 백서</a>를 참고해 주십시오.</p>
                                        </div>
                                    </div>
                                </div>
        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">트링카 유료 요금제는 다른 무료 문법 검사기와 어떻게 다른가요?</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>트링카는 일반적인 문법 검사기가 아닙니다. 트링카는 학술 및 기술 글쓰기를 위한 탁월한 선택입니다. <b>트링카가 무료로 제공해 드리는 베이직 서비스에는 대부분의 다른 프리미엄 문법 검사기보다 더 많은 기능이 포함되어 있습니다.</b> 트링카 프리미엄 서비스는 합리적인 가격을 통해 글쓰기의 모든 요구 사항을 충족하는 더 많은 기능을 제공해 드립니다!</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">트링카의 문법 검사기는 어떤 플랫폼이나 앱에서 사용할 수 있나요?</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p><b>트링카의 문법 검사기는 모든 웹 브라우저에서 사용 가능합니다. 크롬(Chrome), 파이어폭스(Firefox), 사파리(Safari) 및 엣지(Edge) 등 가장 인기 있는 브라우저</b>에서 브라우저 플러그인 형태로 이용 가능하기에, <b>즐겨 찾는 웹사이트에서 문법 수정 작업이 가능합니다.</b> 프리미엄 사용자는 MS 워드(MS Word) 추가 기능으로도 트링카를 사용하실 수 있습니다.</p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">트링카의 문법 검사기를 제가 보유한 독점 소프트웨어와 통합할 수 있을까요?</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>트링카는 통합하기 쉬운 다양한 옵션을 제공해 드립니다. <b>트링카 JS를 사용하면</b> 코드 조각을 삽입하는 단순한 작업을 통해 <b>웹사이트에 문법 검사를 통합할 수 있습니다. 아니면 트링카를 기존 제품이나 워크플로에 통합할 수 있는 트링카 API를 사용할 수도 있습니다.</b></p>
                                        </div>
                                    </div>
                                </div>


                                <div class="card">
                                    <div class="card-header" id="QuestionGCFive">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFiveContent" aria-expanded="true"
                                            aria-controls="QuestionGCFiveContent">작문을 온라인에서 무료로 검사하는 방법은 무엇인가?</a>
                                    </div>
        
                                    <div id="QuestionGCFiveContent" class="collapse"
                                        aria-labelledby="QuestionGCFive" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka를 이용해 온라인에서 무료로 사용자의 작문을 검사할 수 있다. Trinka는 첨단 인공지능 기반 도구로서, 사용자의 글을 더욱 명확하게 그리고 이해하기 쉽게 만들어 준다. Trinka를 이용하면 사소한 구두법 오류와 오타부터 미묘한 문법 실수 및 어법 문제에 이르기까지 모든 점들에 대해 사용자의 글을 검사할 수 있다. 사용자는 Trinka의 Word용 애드인을 이용해 MS Word에서는 물론 Trinka의 브라우저 플러그인을 이용해 인터넷상의 어디에서든 무료로 문법을 검사할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSix">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSixContent" aria-expanded="true"
                                            aria-controls="QuestionGCSixContent">문장이 문법적으로 옳은지 어떻게 검사할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCSixContent" class="collapse"
                                        aria-labelledby="QuestionGCSix" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 스펠링/문법 검사기에 붙여넣기를 하는 간단한 방법으로 문장의 문법 정확성을 검사할 수 있다. Trinka는 문장의 구두법, 문법, 어휘 오류를 전체적으로 검사할 것이다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSeven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSevenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSevenContent">트위터에서는 어떻게 스펠링 검사를 할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCSevenContent" class="collapse"
                                        aria-labelledby="QuestionGCSeven" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>자신이 주로 사용하는 브라우저용의 Trinka 브라우저 플러그인을 설치하고 Trinka가 트윗의 문법을 검사하도록 허용하면 됩니다. 트위터에 대한 실시간 문법 검사를 할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCEight">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCEightContent" aria-expanded="true"
                                            aria-controls="QuestionGCEightContent">Word 파일에 작성된 글의 문법 오류를 온라인에서 어떻게 검사할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCEightContent" class="collapse"
                                        aria-labelledby="QuestionGCEight" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 MS Word 애드인을 설치하면 실시간으로 교정을 받을 수 있다. 또한 애드인 내의 Trinka Auto ile Edit 기능은 사용자의 MS Word 문서를 "변경 내용 추적"(track change)으로 자동 편집할 수 있으며, 그 결과물을 Word의 측면 패널(side panel)에서 다운로드할 수 있다. 프리미엄 회원이 되면 자신의 글을 명료하고 자신감 있게 만들 수 있는 이 강력한 도구를 사용할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCNine">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCNineContent" aria-expanded="true"
                                            aria-controls="QuestionGCNineContent">Trinka 문법 검사기는 어떻게 자동으로 작동하는가?</a>
                                    </div>
        
                                    <div id="QuestionGCNineContent" class="collapse"
                                        aria-labelledby="QuestionGCNine" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 문법 검사기는 다양한 주제에 걸친 수 백만 개의 원고를 이용해 훈련된 첨단 자연어 처리 (NLP) 알고리즘을 이용한다. Trinka는 또한 전체적인 개선을 위해 지속적으로 테스트되고 업데이트 되고 있는 수동 문법 규칙을 통해서도 지속적으로 성능을 향상시키고 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCTen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTenContent" aria-expanded="true"
                                            aria-controls="QuestionGCTenContent">Google에서 나의 문법을 어떻게 검사할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCTenContent" class="collapse"
                                        aria-labelledby="QuestionGCTen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 브라우저 플러그인을 설치하고 자신이 자주 사용하는 브라우저에서 자동으로 실시간 문법 검사를 실행하면 된다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCeleven">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCelevenContent" aria-expanded="true"
                                            aria-controls="QuestionGCelevenContent">Trinka의 문법검사기는 얼마나 정확한가?</a>
                                    </div>
        
                                    <div id="QuestionGCelevenContent" class="collapse"
                                        aria-labelledby="QuestionGCeleven" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 문법 검사기는 아카데믹 내용에 대해 특화되어 설계되었기 때문에 아카데믹/기술 내용에 대한 최고의 무료 문법 검사 도구다. 관련 데이터집합에 관한 우리의 판단에 따르면 Trinka는 일반적으로 90% 이상의 정밀도(precision)와 80% 이상의 재현율(recall)을 보인다.</p>
                                        </div>
                                    </div>
                                </div>
                                

                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwelve">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwelveContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwelveContent">Trinka는 Word 문서에 대해 문법을 검사할 수 있는가? </a>
                                    </div>
        
                                    <div id="QuestionGCTwelveContent" class="collapse"
                                        aria-labelledby="QuestionGCTwelve" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 MS Word 애드인은 실시간 문법 검사를 무료로 제공한다. 또한 Trinka Auto File Edit는 사용자의 MS Word 문서를  "변경 내용 추적"(track change)으로 자동 편집할 수 있으며, 그 결과물을 Word의 측면 패널(side panel)에서 다운로드할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThirteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThirteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCThirteenContent">Trinka 무료 문법 검사기는 문장 구조도 교정하는가? </a>
                                    </div>
        
                                    <div id="QuestionGCThirteenContent" class="collapse"
                                        aria-labelledby="QuestionGCThirteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka 무료 문법 검사기는 문법 검사를 넘어서 사용자 글의 문장 구조, 스타일, 어조, 그리고 그 외 여러 가지를 강화시킨다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFouteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFouteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCFouteenContent">Trinka 스펠링/문법 검사기를 무료로 사용할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCFouteenContent" class="collapse"
                                        aria-labelledby="QuestionGCFouteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka 스펠링/문법 검사기는 이 페이지에서 최대 300단어까지만 무료로 사용할 수 있지만 기본 계획을 이용해 5000단어까지도 무료로 사용할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCFivteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFivteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCFivteenContent">Trinka를 내 문서의 문법 개선 도구로 사용할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCFivteenContent" class="collapse"
                                        aria-labelledby="QuestionGCFivteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka는 문법과 스펠링 이외의 사항까지 다루기 때문에 사용자 문서의 문법만이 아니라 전체적인 언어의 질을 개선시킬 수 있다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSixteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSixteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSixteenContent">Trinka 문법 검사기를 원고에 대해 사용할 수 있는가? </a>
                                    </div>
        
                                    <div id="QuestionGCSixteenContent" class="collapse"
                                        aria-labelledby="QuestionGCSixteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 문법 검사기는 아카데믹 내용 및 포멀/기술 글쓰기에 대해 특화되어 설계되었기 때문에 원고에 대한 최고의 무료 문법 검사 도구다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCSeventeen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCSeventeenContent" aria-expanded="true"
                                            aria-controls="QuestionGCSeventeenContent">Trinka 문법 검사기는 일관성 오류를 인식할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCSeventeenContent" class="collapse"
                                        aria-labelledby="QuestionGCSeventeen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 문법 검사기에는 일관성 검사기라고 알려진 기능이 내장되어 있으며, 단 한번의 클릭으로 5가지의 비 일관성을 파악할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCEighteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCEighteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCEighteenContent">Trinka 문법 검사기는 MS Word 문서를 검사할 수 있는가? </a>
                                    </div>
        
                                    <div id="QuestionGCEighteenContent" class="collapse"
                                        aria-labelledby="QuestionGCEighteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka의 문법 검사기는 MS word 사용자들을 위한 애드인을 제공하며, 또한 자동 파일 편집 기능을 가지고 있기 때문에 사용자 문서의 문법 오류를 수초 내에 자동 검사할 수 있으며 사용자는 모든 제안들을 "변경 내용 추적"으로 확인할 수 있다.  </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCNinteen">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCNinteenContent" aria-expanded="true"
                                            aria-controls="QuestionGCNinteenContent">Trnika 온라인 무료 문법 검사기를 오프라인으로 이용할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGCNinteenContent" class="collapse"
                                        aria-labelledby="QuestionGCNinteen" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trnika 무료 문법 검사기가 실시간 수정을 제공하기 위해서는 인터넷 연결이 필요하다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC20">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC20Content" aria-expanded="true"
                                            aria-controls="QuestionGC20Content">나의 문법이 옳은지를 어디에서 검사할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGC20Content" class="collapse"
                                        aria-labelledby="QuestionGC20" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trnika 무료 실시간 문법 검사기는 사용자의 글이 가장 적절한 형태가 되도록 자동으로 프루프리딩한다. 사용자는 밑줄이 그어진 텍스트에 대해 제시되는 제안을 클릭하여 스펠링 오류와 문법 오류를 교정하거나 스타일 제안을 적용할 수 있다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC21">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC21Content" aria-expanded="true"
                                            aria-controls="QuestionGC21Content">나의 문법을 어디에서 무료로 검사할 수 있는가? </a>
                                    </div>
        
                                    <div id="QuestionGC21Content" class="collapse"
                                        aria-labelledby="QuestionGC21" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>사용자는 Trinka의 기본 계획을 이용하면 Trinka의 브라우저 플러그인을 이용해 인터넷이 연결된 어디에서나 자신의 문법을 검사할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC22">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC22Content" aria-expanded="true"
                                            aria-controls="QuestionGC22Content">Trinka 문법 검사기는 문법 교정시 설명도 함께 제공하는가? </a>
                                    </div>
        
                                    <div id="QuestionGC22Content" class="collapse"
                                        aria-labelledby="QuestionGC22" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>확실히 제공한다! Trinka 문법 검사기는 사용자들이 자신의 실수로부터 교훈을 얻고 변경된 내용을 알 수 있도록 하기 위해 문법 교정시 설명도 함께 제공한다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC23">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC23Content" aria-expanded="true"
                                            aria-controls="QuestionGC23Content">Trinka 문법 검사기가 프루프리딩을 대체할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGC23Content" class="collapse"
                                        aria-labelledby="QuestionGC23" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>원본 글의 질이 그 여부를 결정할 것이다. 영어 사용자가 아닌 경우 그리고 영어의 논리적 구조와 관련해 여러 복잡한 오류를 범하는 경우에 프루프리딩이 도움이 된다. Trinka는 수 천 가지의 문법 오류 및 복잡한 작문 문제들을 수정할 수 있다. 하지만 인공지능에는 한계가 있다. 문장 구조가 논리적이지 않다면 글쓴이가 의도하는 의미를 묘사할 수 없다. 논리적으로 올바른 문장을 구성할 수 있기에 충분한 영어 지식을 가지고 있는 사람들을 위해서 Trinka 문법 검사기는 어조, 단어 선택, 문법 구조, 스펠링, 그리고 기타 여러 가지를 살펴볼 수 있다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC24">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC24Content" aria-expanded="true"
                                            aria-controls="QuestionGC24Content">Trinka 문법 검사기는 구두법을 검사하는가?</a>
                                    </div>
        
                                    <div id="QuestionGC24Content" class="collapse"
                                        aria-labelledby="QuestionGC24" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>구두법을 검사한다. Trinka의 문법 검사기는 구두법을 교정하여 작문의 수준을 높여 준다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC25">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC25Content" aria-expanded="true"
                                            aria-controls="QuestionGC25Content">Trinka 프리미엄 문법 검사기는 학생들에게 할인을 하는가?</a>
                                    </div>
        
                                    <div id="QuestionGC25Content" class="collapse"
                                        aria-labelledby="QuestionGC25" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka 프리미엄 문법 검사기는 학생들에게 20% 할인된 가격을 적용한다. 이 할인을 받기 위해서는 <a href="mailto:support@trinka.ai">support@trinka.ai</a>로 문의해야 한다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC26">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC26Content" aria-expanded="true"
                                            aria-controls="QuestionGC26Content">Trinka 문법 검사기는 영어 이외의 언어도 지원하는가?</a>
                                    </div>
        
                                    <div id="QuestionGC26Content" class="collapse"
                                        aria-labelledby="QuestionGC26" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka 문법 검사기는 영어만 지원한다. </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC27">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC27Content" aria-expanded="true"
                                            aria-controls="QuestionGC27Content">Trinka 문법 검사기 도구는 어떤 웹사이트에서 기능을 하는가?</a>
                                    </div>
        
                                    <div id="QuestionGC27Content" class="collapse"
                                        aria-labelledby="QuestionGC27" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>자신이 사용하는 브라우저에 따라 Trinka 브라우저 플러그인을 선택하면, Trinka 무료 문법 검사기를 모든 웹사이트에서 사용할 수 있다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC28">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC28Content" aria-expanded="true"
                                            aria-controls="QuestionGC28Content">Trinka 문법 검사기 도구를 지원하는 앱은 무엇인가? </a>
                                    </div>
        
                                    <div id="QuestionGC28Content" class="collapse"
                                        aria-labelledby="QuestionGC28" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka 기본 계획에 구독하고 Trinka 브라우저 플러그인을 다운로드한 사용자는 모든 웹사이트에 접근할 수 있고 어디에서도 자신의 문법을 온라인으로 교정할 수 있다. 사용자는 또한 MS Word 문서용인 Trinka Word 애드인을 사용할 수 있다.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC29">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC29Content" aria-expanded="true"
                                            aria-controls="QuestionGC29Content">Trinka 문법 검사기는 어떤 종류의 영어 오류를 교정할 수 있는가?</a>
                                    </div>
        
                                    <div id="QuestionGC29Content" class="collapse"
                                        aria-labelledby="QuestionGC29" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Trinka 문법 검사기는 스펠링과 문법 이외에도 구두법, 문장 구조, 어조 등을 개선해 글의 수준을 높여 준다.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGC30">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGC30Content" aria-expanded="true"
                                            aria-controls="QuestionGC30Content">Trinka 문법 검사기는 논문의 문법 검사에도 이용될 수 있는가? </a>
                                    </div>
        
                                    <div id="QuestionGC30Content" class="collapse"
                                        aria-labelledby="QuestionGC30" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>이용될 수 있다. Trinka 문법 검사기는 아카데믹/기술 문서의 교정에 특화되어 있다. 우리는 사용자에게 논문, 연구 페이퍼, 보고서, 에세이 및 기타 포멀한 문서의 교정에 Trinka를 사용할 것을 권장한다.</p>
                                        </div>
                                    </div>
                                </div>
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="users">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="users">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="users">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<!-- Modal -->
<div class="modal fade" id="usageLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="usageLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedExceededPopup" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="upgradePremiumSection">
            <div class="upgradeHeaderSection">
               <div class="upgradeHeaderSection_overlay"></div>
               <h3>앗! 콘텐츠 제한을 초과했습니다.</h3>
            </div>
            <div class="upgradeBodySection">
               <!-- <h2>Sign Up for free and get 5000 words/month</h2> -->
               <p style="margin: 0; margin-top: 10px;">무료 트링카 계정에서는 매달 최대 5000단어까지 글을 확인할 수 있습니다. </p>
               <!-- <p> All you need to do is Sign Up for free.</p> -->
               <div class="goupgradeButton">
                  <a href="https://cloud.trinka.ai/signup?_rg=KR" target="_blank">무료 가입하기</a>
                  <button id="FooterClosedExceededPopup">편집기로 돌아가기</button>
               </div>
            </div>
         </div>
      </div>
    </div>
  </div>

    <!--Modal for accept limit exceeded-->
    <div class="modal fade" id="acceptedLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="acceptedLimitExhaustedLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <button type="button" id="closedAcceptedLimitExhaustedPopup"   (click)="hideModal1()" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
             <div class="limitExhaustedBody">
                 <div class="limitExhaustedLeftContent">
                     <div class="logoSection">
                         <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                     </div>
                     <div class="ExhaustedLeftContent">
                         <h2>더 많은 문법 수정 및 원클릭 편집.</h2>
                         <a href="https://cloud.trinka.ai/signup?_rg=Grammar-Checker-JS-KR" target="_blank">무료 계정 받기</a>
                     </div>
                 </div>
                 <div class="limitExhaustedRightContent">
                     <div class="rightInnerContent">
                         <img class="backgourndImageSection" src="../../../assets/images/home_banner.jpg" alt="home banner">
                         <div class="imagesOverlaySection"></div>
                     </div>
                     <div class="ExhastedRightContainer">
                        <img src="../../../assets/images/GC_grammarCheckCard.png" class="grammarCheckCardImg" alt="card" >
                        <img src="../../../assets/images/GC_EnhanCheckCard.png" class="EnhanmentCheckCardImg" alt="card" >
                        <a href="https://cloud.trinka.ai/signup?_rg=Grammar-Checker-JS-KR" target="_blank">무료 계정 받기</a>
                    </div>
                 </div>
             </div>
          </div>
        </div>
      </div>